// @flow

import type { EmployeePositionsState } from "./types";

export const initialState: EmployeePositionsState = {
  error: null,
  list: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
      sort: {
        orders: [],
      },
    },
    totalElements: 0,
  },
};

export default initialState;
